import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { TrendingUp, TrendingDown, Target, DollarSign, BarChart3, Award } from 'lucide-react';

const StatCard = ({ label, value, valueClass = 'text-gray-900', Icon, iconClass = 'text-purple-600' }) => (
  <Card className="bg-white">
    <CardContent className="pt-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-gray-500">{label}</p>
          <p className={`text-2xl font-bold ${valueClass}`}>{value}</p>
        </div>
        <Icon className={iconClass} size={24} />
      </div>
    </CardContent>
  </Card>
);

const JournalStats = ({ stats }) => {
  if (!stats) return null;
  const winRateGood = stats.winRate >= 50;
  const pnlGood = stats.totalPnl >= 0;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4" data-testid="journal-stats">
      <StatCard label="Total Trades" value={stats.totalTrades} Icon={BarChart3} />
      <StatCard
        label="Win Rate"
        value={`${stats.winRate}%`}
        valueClass={winRateGood ? 'text-green-600' : 'text-red-600'}
        Icon={Award}
        iconClass={winRateGood ? 'text-green-600' : 'text-red-600'}
      />
      <StatCard
        label="Total P&L"
        value={`$${stats.totalPnl.toLocaleString()}`}
        valueClass={pnlGood ? 'text-green-600' : 'text-red-600'}
        Icon={DollarSign}
        iconClass={pnlGood ? 'text-green-600' : 'text-red-600'}
      />
      <StatCard label="Profit Factor" value={stats.profitFactor} Icon={Target} />
      <StatCard label="Best Trade" value={`$${stats.bestTrade}`} valueClass="text-green-600" Icon={TrendingUp} iconClass="text-green-600" />
      <StatCard label="Worst Trade" value={`$${stats.worstTrade}`} valueClass="text-red-600" Icon={TrendingDown} iconClass="text-red-600" />
    </div>
  );
};

export default JournalStats;
